import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/video-icon-play.svg';
import { mapMutations } from 'vuex';

var SquareImage = function SquareImage() {
  return import(
  /* webpackChunkName: "square-image" */
  '~/components/atoms/Product/SquareImage.vue');
};

var ThumbnailListArrowButton = function ThumbnailListArrowButton() {
  return import(
  /* webpackChunkName: "thumbnail-list" */
  '~/components/molecules/Product/ThumbnailListArrowButton.vue');
};

export default {
  name: 'ThumbnailList',
  components: {
    SquareImage: SquareImage,
    ThumbnailListArrowButton: ThumbnailListArrowButton
  },
  props: {
    medias: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isSlider: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentIndex: this.index
    };
  },
  computed: {
    maxIndex: function maxIndex() {
      return this.medias.length - 1;
    }
  },
  watch: {
    index: function index(newValue) {
      if (newValue !== this.currentIndex) {
        this.currentIndex = newValue;
        this.scroll();
      }
    },
    images: function images() {
      this.updateIndex(0);
    }
  },
  mounted: function mounted() {
    if (this.index > 0) {
      this.scroll(false);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  })), {}, {
    isVideo: function isVideo(media) {
      return media.type;
    },
    updateIndex: function updateIndex(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.$emit('update:index', this.currentIndex);
      }
    },
    selectIndexAndScroll: function selectIndexAndScroll(index) {
      this.updateIndex(index);
      this.scroll();
    },
    incrementIndex: function incrementIndex() {
      if (this.currentIndex + 1 < this.medias.length) {
        this.currentIndex += 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },
    decrementIndex: function decrementIndex() {
      if (this.currentIndex - 1 >= 0) {
        this.currentIndex -= 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },
    scroll: function scroll() {
      var smooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var scrollSize = this.$refs.thumbnail[0].offsetHeight * this.currentIndex;
      this.$refs.slider.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.$refs.wrapper.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  })
};